import React from "react";
import { FormattedMessage } from "react-intl";
import { Cancel } from "../../../components/Form";
import PlanCard from "../../../components/PlanCard";

import messages from "./messages";
import {
    PlanCardListContainer,
    PlanCardContainer,
} from "./styles";
import { IProps } from "./interfaces";
import { IPlan } from "../../../../common/types";

const HomeworkList = ({ homeworks, cancelToClasses }: IProps) => (
    <div>
        <PlanCardListContainer>
            {homeworks.map(homework => (
                <PlanCardContainer key={homework._id}>
                    <PlanCard plan={{ ...homework, name: homework.title } as unknown as IPlan} homework />
                </PlanCardContainer>
            ))}
        </PlanCardListContainer>
        <Cancel onClick={cancelToClasses}>
            <FormattedMessage {...messages.back} />
        </Cancel>
    </div>
);

export default HomeworkList;
